import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

const DeleteConfirmDialog = ({ 
    open, 
    onClose, 
    onConfirm 
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Підтвердити видалення</DialogTitle>
            <DialogContent>
                Ви впевнені, що хочете видалити цю конфігурацію? Цю дію неможливо скасувати.
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Скасувати</Button>
                <Button onClick={onConfirm} color="error" variant="contained">
                    Видалити
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;
